module.exports = __webpack_public_path__ + "static/media/Ranking-Camiseta-Light.152c3514.png";